(function() {
  'use strict';
  angular.module('cp.folderselector', ['qstrap']);
})();


angular.module('cp.folderselector').controller('FolderSelectorController', ['$scope', 'folderSelectorService',
  function($scope, folderSelectorService) {

    $scope.shouldSpin = function() {
      return $scope.busy && !$scope.selectorText;
    };

    $scope.getFolders = function() {
      $scope.busy = true;
      $scope.foldersPromise = folderSelectorService.getFoldersFlat($scope.folderData, $scope.isContentSelector);
      //selected folder - passed in or first in list
      selectOnFoldersLoaded($scope.model);
    };

    $scope.destinationSelected = function(id) {
      if ($scope.isContentSelector) {
        elementSelected(id);
      } else {
        folderSelected(id);
      }
    };

    function selectOnFoldersLoaded(id) {
      $scope.foldersPromise.then(function(folders) {
        $scope.busy = false;

        $scope.selectedFolderId = null;
        $scope.selectedElementId = null;
        $scope.folders = folders;
        if(!id && $scope.autoSelect && !$scope.isContentSelector && folders.length) {
          id = folders[0].folderId;
        }
        if(id && !$scope.selectorText)  {
          if($scope.isContentSelector) {
            setElement(id, findContainingFolder(id));
          }
          else {
            setFolder(findFolder(id));
          }
        }
      });
    }

    /**
     * by this time we should have the folders
     */
    function folderSelected(folderId) {
      var folder = findFolder(folderId);
      if (setFolder(folder)) {
        $scope.afterSelect({
          $folderId: folderId,
          $folderName: folder.name
        });
      }
    }

    function setFolder(folder) {
      if (folder) {
        $scope.model = folder.folderId;
        $scope.selectorText = folder.name;
        return true;
      }
      return false;
    }

    function elementSelected(elementId) {
      var containingFolder = findContainingFolder(elementId);
      if (setElement(elementId, containingFolder)) {
        $scope.afterSelect({
          elementId: elementId,
          elementName: $scope.selectorText
        });
        $scope.blowCache();
      }
    }

    function setElement(elementId, containingFolder) {
      if(containingFolder) {
        $scope.model = elementId;
        $scope.selectedFolderId = containingFolder.folderId;
        $scope.selectorText = folderSelectorService.getElementName(elementId);
        return true;
      }
      return false;
    }

    /**
     * Searches $scope.folders for a specific folder
     */
    function findFolder(folderId) {
      for (var i = 0; i < $scope.folders.length; i++) {
        if ($scope.folders[i].folderId === folderId) {
          return $scope.folders[i];
        }
      }
    }

    /**
     * Finds the folder that contains the given survey
     */
    function findContainingFolder(elementId) {
      for (var i = 0; i < $scope.folders.length; i++) {
        if ($scope.folders[i].contents) {
          if (elementId in $scope.folders[i].contents) {
            return $scope.folders[i];
          }
        }
      }
    }

    $scope.$watch('autoSelect', function(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        selectOnFoldersLoaded($scope.model);
      }
    });

    $scope.$watch('folderData', function(newValue, oldValue) {
      if(newValue !== oldValue) {
        folderSelectorService.deleteConstructedContents();
        $scope.getFolders();
        $scope.blowCache();
        $scope.$emit('foldersSet');
      }
    });
  }
]);

angular.module('cp.folderselector').directive('folderSelector', [
  '$filter',
  function($filter) {

    var escape = $filter('escapeHtml');

    return {
      restrict: 'AE',
      scope: {
        model: '=ngModel',
        btnClass: '@',
        folderData: '=',
        afterSelect: '&',
        emptyListMessage: '=?',
        invert: '=?',

        /**
         * Whether or not the button shows a spinner. This is managed mostly
         * internally, but gives access to the state. Defaults to false.
         */
        busy: '=?',

        /**
         * The name of the element that is currently selected. If this is set
         * while folderData is a promise, the button will display this text
         * rather than a spinner. Note that the text does not override the
         * actual busy state, just the view.
         */
        selectorText: '=?',

        /* These scope variables are specific to content selector and could be taken away into a
          content selector that could inherit from the folder selector */
        searchAllElements: '=?', // Object - {title, className, icon, searchText, emptyText}
        sortFunction: '&?' // Function - how contents are sorted within a folder
      },
      /**
       * @param  {} attrs.contentSelector - if truthy will make this folderselector a survey selector. suveys show up in the folders
       *            attrs.autoSelect - if truthy, will use ng-model as an id to select folder/content by default
       *            attrs.contentIcon - if it exists, will set the class for the content icon (can be empty string for no icon)
       *            attrs.isLink - setting isLink/isButton for qstrap menu
       */
      link: {
        pre: function preLink(scope) {
          scope.menuOpts = {
            className: "folder-select-menu"
          };
        },
        post: function postLink(scope, element, attrs) {
          if (!attrs.autoSelect || attrs.autoSelect !== 'false') {
            scope.autoSelect = true;
          }
          if (attrs.contentSelector) {
            scope.isContentSelector = true;
          }

          if (!attrs.isLink) {
            scope.isButton = true;
          } else {
            scope.isLink = true;
          }

          if (!attrs.busy) {
            scope.busy = false;
          }

          var defaultSearchAllElements = {
            title: 'All Surveys',
            className: '',
            icon: 'icon-list-framed'
          };

          if (!scope.searchAllElements) {
            scope.searchAllElements = defaultSearchAllElements;
          }

          //If they have provided no icon, use the survey icon default
          var defaultIcon;
          if (attrs.hasOwnProperty('contentIcon')) {
            defaultIcon = attrs.contentIcon;
          } else {
            defaultIcon = 'icon-survey-wire';
          }
          var iconSelected = '';


          //Construct the localized text object for qstrap
          scope.menuOpts.localizedText = {
            emptyText: scope.emptyListMessage || scope.searchAllElements.emptyText,
            searchText: scope.searchAllElements.searchText
          };

          //get the folders now that we know if its a contentselector
          scope.getFolders();
          scope.foldersPromise.then(function(folders) {
            if (folders.length !== 1 || !scope.isContentSelector) {
              scope.menuOpts.searchable = false;
            } else {
              scope.menuOpts.searchable = true;
            }
          });

          var menuDefItems;
          var allSubMenuItems;
          scope.getMenuDefItems = function() {
            if (menuDefItems) {
              return menuDefItems;
            }

            var menuBuilder = buildFolderSelectMenu;
            if (scope.isContentSelector) {
              menuBuilder = buildItemSelectMenu;
            }
            return scope.foldersPromise.then(function (folders) {
              var menuItems = menuBuilder(folders);
              // if an empty list message has been provided and the list we get back
              // is empty, include a disabled placeholder to let them know there are no results
              if (menuItems.length === 0 && scope.emptyListMessage) {
                var emptyItem = {
                  label: scope.emptyListMessage,
                  value: 'EMPTY',
                  selectable: false,
                  disabled: true
                };

                menuItems.push(emptyItem);
              }

              return menuItems;
            });
          };

          scope.$on('deleteMenuDefItems', function() {
            scope.blowCache();
          });

          scope.blowCache = function() {
            menuDefItems = null;
            allSubMenuItems = null;
          };

          function getIndentLevel(folder) {
            var indent = (12 * folder.hierarchyLevel);
            if (scope.isContentSelector) {
              indent -= 12;
            }
            return indent;
          }

          function buildItemSelectMenu(folders) {
            if (!folders) {
              folders = scope.folders;
            }
            var menuItems;
            //if there is more than one folder, display the elements in their folders
            if (folders.length > 1) {
              menuItems = buildFolderSelectMenu(folders);
            } else if (folders.length === 1) {
              //if there is only one folder, just show the contents of that folder
              iconSelected += ' highlight-selected';
              var itemMenuDef = generateContentsMenuDef(folders[0], true);
              menuItems = itemMenuDef.items;
            } else {
              // if there are no folders, we just return an empty list
              menuItems = [];
            }

            return menuItems;
          }

          function buildFolderSelectMenu(folders) {
            if (!folders) {
              folders = scope.folders;
            }
            var items = [];
            var className = 'folder-select-menu-item';

            if (scope.isContentSelector) {
              className += ' content-selector';
            }

            for (var i = 0; i < folders.length; ++i) {
              var folder = folders[i];
              var itemEl = angular.element('<div class="' + className + '"><div class="icon icon-folder-wire"></div><div class="icon icon-folder"></div><span title="' + escape(folder.name) + '" class="folder-title">' + escape(folder.name) + '</span></div>');
              itemEl.css({
                'margin-left': getIndentLevel(folder)
              });

              var item = {
                label: itemEl,
                value: folder.folderId,
                selectable: !scope.isContentSelector,
                selected: scope.selectedFolderId === folder.folderId
              };

              if (scope.isContentSelector) {
                if (folder.contents && Object.keys(folder.contents).length) {
                  item.submenu = generateContentsMenuDef(folder);
                } else {
                  item.disabled = true;
                }
              }
              items.push(item);
            }

            if (scope.isContentSelector) {
              var allContentsClassName = escape(scope.searchAllElements.className) || '';
              var allContentsIcon = escape(scope.searchAllElements.icon) || '';
              var allContentsTitle = escape(scope.searchAllElements.title) || '';

              var allContentsElement = angular.element('<div class="' + className + ' ' + allContentsClassName + '"><div class="icon ' + allContentsIcon + '"></div><span class="folder-title">' + allContentsTitle + '</span></div>');
              allContentsElement.css({
                'margin-left': 0
              });
              items.unshift({
                label: allContentsElement,
                submenu: {
                  searchable: true,
                  items: allSubMenuItems
                }
              });
            }

            menuDefItems = items;
            return items;
          }

          /**
           * these are surveys with callbacks to
           */
          function generateContentsMenuDef(folder, isMainMenu) {
            var contents = folder.contents;
            var submenuDef = [];
            if (!allSubMenuItems) {
              allSubMenuItems = [];
            }
            var mainMenuClass = isMainMenu ? 'main-menu-item' : '';
            for (var surveyId in contents) {
              var content = contents[surveyId];
              var name = escape(content.name);
              var icon = escape(defaultIcon);
              if (content.icon) {
                icon = escape(content.icon);
              }
              var surveyNode = angular.element('<div class="content-select-menu-item ' + mainMenuClass + '"><div class="icon default-icon ' + icon + iconSelected+'"></div><span title="' + name + '" class="survey-title">' + name + '</span></div>');
              var submenuItem = {
                label: surveyNode,
                value: surveyId,
                selected: scope.selectedSurveyId === surveyId
              };
              submenuDef.push(submenuItem);
              allSubMenuItems.push(submenuItem);
            }

            return {
              items: submenuDef
            };
          }
        }
      },
      templateUrl: 'src/js/templates/folderSelector.html',
      controller: 'FolderSelectorController'
    };
  }
]);

// http://stackoverflow.com/questions/14462612/escape-html-text-in-an-angularjs-directive
angular.module('cp.folderselector').filter('escapeHtml', function () {

  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  };

  return function(str) {
    return String(str).replace(/[&<>"'\/]/g,
      function (s) {
        return entityMap[s];
      }
    );
  };
});

angular.module('cp.folderselector')
  .factory('folderSelectorService', ['$q',
    function($q) {

      /** just like the flat folders map but with a contents submenu */
      var constructedSurveysInFolders;

      /** {folderId: {elementId: surveyName, ...}, ...} */
      var folderToContentsMap;
      /** {elementId: surveyName, ...} */
      var elementNameMap;
      /** {folderId: int, ...} */
      var countMap;

      var folderNameMap, folderHierarchyMap;

      var uncategorizedFolderId = '-1';

      function deleteConstructedContents() {
        constructedSurveysInFolders = undefined;
      }

      var rootFolderId = 'ROOT';
      /**
       * Takes a folder object and flattens the folder hierarchy into an array with hierarchy levels
       * @return {Array} flat folders list.
       *   This should include data such as name, folderId, hasChildren, count, heirarchy level
       */
      function getFoldersFlat(fldData, includeContent) {
        var promise;
        if(fldData.then) {
          promise = fldData;
        }
        else {
          var deferred = $q.defer();
          promise = deferred.promise;
          deferred.resolve(fldData);
        }

        return promise.then(function(fld) {
          return flattenFolderObject(fld, includeContent);
        });
      }

      function flattenFolderObject(fldData, includeContent) {
        // capture maps -> empty objects/default folder hierarchy
        folderNameMap = fldData.Folders || {};
        folderHierarchyMap = fldData.FolderHierarchy || emptyFolderHierarchy();
        fldData.Elements = fldData.Elements || {};

        var flatFolders = [];
        if (folderNameMap[uncategorizedFolderId]) {
          flatFolders.push(buildFlatFolder(uncategorizedFolderId, 1));
        }
        flatFolders = flatFolders.concat(buildFlatChildFolderList(rootFolderId, 1));

        if (includeContent && hasElementNames(fldData)) {
          if (Object.keys(folderNameMap).length === 0) {
            flatFolders.push(buildFlatFolder(uncategorizedFolderId, 1));
          }
          constructMaps(fldData);
          flatFolders = constructFolderContents(flatFolders);
        }
        return flatFolders;
      }

      function hasElementNames(fldData) {
        // ElementNames might be undefined, or an empty object. In either case, there are no elements for content
        return typeof fldData.ElementNames === 'object' && Object.keys(fldData.ElementNames).length !== 0;
      }

      function emptyFolderHierarchy() {
        var hierarchy = {};
        hierarchy[rootFolderId] = [];
        return hierarchy;
      }

      /**
       * Builds a flat list of folders recursively from the root
       * @param  {String} parentFolderId
       * @param  {Number} level how many parents until you hit the ROOT
       * @return {Array} list of FlatFolders
       */
      function buildFlatChildFolderList(parentFolderId, level) {
        var list = [];
        var order = getAlphabeticalFolderSortOrder(parentFolderId);
        for (var i = 0; i < order.length; ++i) {
          var currentFolderId = order[i];
          if (currentFolderId !== uncategorizedFolderId) {
            var currentFolder = buildFlatFolder(currentFolderId, level);
            list.push(currentFolder);
            if (hasChildFolders(currentFolderId)) {
              var children = buildFlatChildFolderList(currentFolderId, level + 1);
              list = list.concat(children);
            }
          }
        }
        return list;
      }

      /**
       * Builds the folder with data needed for showing it in a flat list.
       * @param  {String} folderId
       * @param  {Number} level - how deep in the hierarchy this folder exists at (how many parents until you hit the ROOT)
       * @return {Object} attributes: name, folderId, hierarchyLevel, hasChildren
       */
      function buildFlatFolder(folderId, level) {
        var folder = {
          name: folderNameMap[folderId],
          folderId: folderId,
          hierarchyLevel: level
        };
        return folder;
      }

      /**
       * @return {Boolean} whether the folder contains other folders
       */
      function hasChildFolders(folderId) {
        return !!(folderHierarchyMap[folderId] && folderHierarchyMap[folderId].length);
      }

      function getAlphabeticalFolderSortOrder(parentFolderId) {
        var order = [];
        var children = folderHierarchyMap[parentFolderId] || [];
        for (var i = 0; i < children.length; ++i) {
          order.push(folderHierarchyMap[parentFolderId][i]);
        }
        order.sort(
          function(folderId1, folderId2) {
            return folderNameMap[folderId1].localeCompare(folderNameMap[folderId2]);
          });
        return order;
      }

      function constructFolderContents(flatFolders) {
        var elementsInFolders = [];
        for (var i = 0; i < flatFolders.length; ++i) {
          var folderWithSurveys = flatFolders[i];
          var folderId = folderWithSurveys.folderId;
          folderWithSurveys.contents = folderToContentsMap[folderId];
          elementsInFolders.push(folderWithSurveys);
        }
        return elementsInFolders;
      }

      function constructMaps(fldData) {
        folderToContentsMap = {};
        elementNameMap = {};
        countMap = {};

        for (var elementId in fldData.ElementNames) {
          var folderId = fldData.Elements[elementId] || uncategorizedFolderId;
          var elementName = fldData.ElementNames[elementId];
          elementNameMap[elementId] = elementName;
          var content = {
            name:elementName
          };
          if (fldData.ElementIcons && fldData.ElementIcons[elementId]) {
            content.icon = fldData.ElementIcons[elementId];
          }
          if (!folderToContentsMap[folderId]) {
            folderToContentsMap[folderId] = {};
          }
          folderToContentsMap[folderId][elementId] = content;
        }
      }

      function getElementName(elementId) {
        return elementNameMap[elementId];
      }

      return {
        constructFolderContents: constructFolderContents,
        getElementName: getElementName,
        getFoldersFlat: getFoldersFlat,
        deleteConstructedContents: deleteConstructedContents
      };
    }
  ]);
angular.module('cp.folderselector').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('src/js/templates/folderSelector.html',
    "<div qstrap.select-menu ng-model=\"model\" items=\"getMenuDefItems()\" options=\"menuOpts\" on-change=\"destinationSelected($value, $item, $event)\" class=\"q-folder-selector {{ btnClass }}\" ng-class=\"{active: menuIsOpen, 'btn btn-select':isButton, 'btn btn-hover btn-inverted btn-select':isLink}\"><span qstrap.spin spin-invert=\"{{ invert }}\" spin-if=\"shouldSpin()\"></span> <span class=\"selector-text\" ng-show=\"!shouldSpin()\">{{ selectorText }}</span><div class=\"caret\" ng-show=\"!shouldSpin()\"></div></div>"
  );

}]);
